<div
  class="flex flex-row gap-2 p-4 items-center w-full rounded-lg"
  [ngClass]="{ info: isInfo, warning: isWarning, danger: isDanger }"
>
  <div class="flex flex-row flex-1 gap-2 md:gap-4 lg:gap-4 items-center">
    @if (showIcon) {
      <!-- mobile icon -->
      <i nz-icon class="only-mobile">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path
            d="M7.99992 1.83325C11.6819 1.83325 14.6666 4.81859 14.6666 8.49992C14.6666 12.1813 11.6819 15.1666 7.99992 15.1666C4.31792 15.1666 1.33325 12.1813 1.33325 8.49992C1.33325 4.81859 4.31792 1.83325 7.99992 1.83325ZM8.00112 10.5024C7.63345 10.5024 7.33532 10.8005 7.33532 11.1682C7.33532 11.5359 7.63345 11.8339 8.00112 11.8339C8.36879 11.8339 8.66692 11.5359 8.66692 11.1682C8.66692 10.8005 8.36879 10.5024 8.00112 10.5024ZM7.99965 5.16659C7.65779 5.16671 7.37612 5.42417 7.33772 5.75575L7.33325 5.83349L7.33445 9.16739L7.33899 9.24519C7.37759 9.57672 7.65945 9.83399 8.00139 9.83385C8.34325 9.83372 8.62492 9.57625 8.66332 9.24465L8.66779 9.16692L8.66659 5.83301L8.66205 5.75527C8.62345 5.42372 8.34159 5.16647 7.99965 5.16659Z"
            fill="#222528"
          />
        </svg>
      </i>
      <!-- desktop icon -->
      <i nz-icon class="only-desktop">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12C2 6.478 6.477 2 12 2ZM12.0018 15.0037C11.4503 15.0037 11.0031 15.4508 11.0031 16.0024C11.0031 16.5539 11.4503 17.001 12.0018 17.001C12.5533 17.001 13.0005 16.5539 13.0005 16.0024C13.0005 15.4508 12.5533 15.0037 12.0018 15.0037ZM11.9996 7C11.4868 7.00018 11.0643 7.38638 11.0067 7.88374L11 8.00036L11.0018 13.0012L11.0086 13.1179C11.0665 13.6152 11.4893 14.0011 12.0022 14.0009C12.515 14.0007 12.9375 13.6145 12.9951 13.1171L13.0018 13.0005L13 7.99964L12.9932 7.88302C12.9353 7.3857 12.5125 6.99982 11.9996 7Z"
            fill="#222528"
          />
        </svg>
      </i>
    }
    @if (localizableText) {
      <span class="content text-left">{{ localizableText | translate }}</span>
    } @else {
      <span class="content text-left"><ng-content></ng-content></span>
    }
  </div>
  @if (closable) {
    <div>
      <button nz-button nzType="text" (click)="onCloseClick()">
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
              d="M2.93129 3.53578L2.9797 3.4797C3.15721 3.30219 3.43499 3.28605 3.63073 3.43129L3.68681 3.4797L7.99992 7.79259L12.3131 3.4797C12.5083 3.28444 12.8249 3.28444 13.0201 3.4797C13.2154 3.67496 13.2154 3.99155 13.0201 4.18681L8.70725 8.49992L13.0201 12.8131C13.1977 12.9905 13.2138 13.2683 13.0685 13.4641L13.0201 13.5201C12.8427 13.6977 12.5649 13.7138 12.3691 13.5685L12.3131 13.5201L7.99992 9.20725L3.68681 13.5201C3.49155 13.7154 3.17496 13.7154 2.9797 13.5201C2.78444 13.3249 2.78444 13.0083 2.9797 12.8131L7.29259 8.49992L2.9797 4.18681C2.80219 4.00929 2.78605 3.73152 2.93129 3.53578Z"
              fill="#222528"
            />
          </svg>
        </i>
      </button>
    </div>
  }
</div>
